/* Editorial — theme.js (vanilla, no dependencies) */
(function () {
'use strict';
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
/* ---------- Money ---------- */
function formatMoney(cents, format) {
format = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
const value = (cents / 100).toFixed(2);
const [whole, dec] = value.split('.');
const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
let out = format;
out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas);
out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec);
out = out.replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + dec);
return out;
}
window.formatMoney = formatMoney;
/* ---------- Overlay & drawers ---------- */
const overlay = $('[data-overlay]');
let openDrawer = null;
function lockScroll(lock) { document.documentElement.style.overflow = lock ? 'hidden' : ''; }
function closeDrawers() {
$$('.drawer.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
overlay && overlay.classList.remove('is-active');
document.body.classList.remove('menu-open');
$('.header-wrap') && $('.header-wrap').classList.remove('menu-open');
lockScroll(false);
openDrawer = null;
}
function openDrawerById(id) {
const d = document.getElementById(id);
if (!d) return;
closeDrawers();
d.classList.add('is-open');
d.setAttribute('aria-hidden', 'false');
overlay && overlay.classList.add('is-active');
lockScroll(true);
openDrawer = d;
if (id === 'MenuDrawer') { document.body.classList.add('menu-open'); $('.header-wrap') && $('.header-wrap').classList.add('menu-open'); }
const focusable = d.querySelector('button, a, input');
focusable && setTimeout(() => focusable.focus(), 50);
}
window.openDrawer = openDrawerById;
window.closeDrawers = closeDrawers;
document.addEventListener('click', e => {
const opener = e.target.closest('[data-open-drawer]');
if (opener) { e.preventDefault(); openDrawerById(opener.getAttribute('data-open-drawer')); return; }
if (e.target.closest('[data-close-drawer]') || e.target === overlay) { closeDrawers(); }
});
document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrawers(); closePopup(); } });
/* ---------- Header scroll state ---------- */
const header = $('.header-wrap');
if (header) {
const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
onScroll();
window.addEventListener('scroll', onScroll, { passive: true });
}
/* ---------- Reveal on scroll ---------- */
if ('IntersectionObserver' in window) {
const io = new IntersectionObserver(entries => {
entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
$$('[data-reveal], [data-reveal-stagger]').forEach(el => io.observe(el));
} else {
$$('[data-reveal], [data-reveal-stagger]').forEach(el => el.classList.add('is-visible'));
}
/* ---------- Hero slideshow ---------- */
$$('[data-slideshow]').forEach(hero => {
const slides = $$('.hero__slide', hero);
const dots = $$('.hero__dot', hero);
if (slides.length < 2) return;
let i = 0, timer = null;
const autoplay = hero.dataset.autoplay === 'true';
const speed = (parseInt(hero.dataset.speed, 10) || 7) * 1000;
function go(n) {
slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
i = (n + slides.length) % slides.length;
slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
}
function start() { if (autoplay) { stop(); timer = setInterval(() => go(i + 1), speed); } }
function stop() { if (timer) clearInterval(timer); }
dots.forEach((d, n) => d.addEventListener('click', () => { go(n); start(); }));
$$('[data-prev]', hero).forEach(b => b.addEventListener('click', () => { go(i - 1); start(); }));
$$('[data-next]', hero).forEach(b => b.addEventListener('click', () => { go(i + 1); start(); }));
hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
let sx = 0;
hero.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
hero.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) { go(dx < 0 ? i + 1 : i - 1); start(); } });
start();
});
/* ---------- Testimonials scroller ---------- */
$$('[data-scroller]').forEach(wrap => {
const track = $('[data-scroller-track]', wrap);
if (!track) return;
const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 24 : 320);
$$('[data-scroll-prev]', wrap).forEach(b => b.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
$$('[data-scroll-next]', wrap).forEach(b => b.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
});
/* ---------- Cart ---------- */
const Cart = {
async fetch() { const r = await fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); },
async add(formData) {
const r = await fetch(theme.routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
const data = await r.json();
if (!r.ok) throw data;
return data;
},
async change(line, quantity) {
const r = await fetch(theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
return r.json();
},
async refreshDrawer() {
const r = await fetch(theme.routes.cartUrl + '?section_id=cart-drawer');
const html = await r.text();
const doc = new DOMParser().parseFromString(html, 'text/html');
const fresh = doc.querySelector('#CartDrawer');
const current = document.querySelector('#CartDrawer');
if (fresh && current) {
const wasOpen = current.classList.contains('is-open');
current.innerHTML = fresh.innerHTML;
if (wasOpen) current.classList.add('is-open');
}
const count = doc.querySelector('[data-cart-count]');
if (count) $$('[data-cart-count]').forEach(c => { c.textContent = count.textContent; });
document.dispatchEvent(new CustomEvent('cart:refreshed'));
},
async refreshPage() {
const r = await fetch(theme.routes.cartUrl + '?section_id=main-cart');
const html = await r.text();
const doc = new DOMParser().parseFromString(html, 'text/html');
const fresh = doc.querySelector('[data-cart-page]');
const current = document.querySelector('[data-cart-page]');
if (fresh && current) current.innerHTML = fresh.innerHTML;
const count = doc.querySelector('[data-cart-count]');
if (count) $$('[data-cart-count]').forEach(c => { c.textContent = count.textContent; });
}
};
window.Cart = Cart;
// Add-to-cart forms (product page & quick add)
document.addEventListener('submit', async e => {
const form = e.target.closest('form[data-ajax-cart]');
if (!form) return;
e.preventDefault();
const btn = form.querySelector('[type="submit"]');
const label = btn ? btn.querySelector('[data-label]') || btn : null;
const original = label ? label.textContent : '';
if (btn) { btn.setAttribute('aria-disabled', 'true'); if (label) label.textContent = theme.strings.adding; }
try {
const fd = new FormData(form);
fd.append('sections', 'cart-drawer');
await Cart.add(fd);
await Cart.refreshDrawer();
if (label) label.textContent = theme.strings.added;
if (document.body.dataset.cartType !== 'page') openDrawerById('CartDrawer');
else window.location.href = theme.routes.cartUrl;
} catch (err) {
const msg = form.querySelector('[data-form-error]');
if (msg) { msg.textContent = (err && (err.description || err.message)) || 'Something went wrong.'; msg.hidden = false; }
} finally {
setTimeout(() => { if (btn) { btn.removeAttribute('aria-disabled'); if (label) label.textContent = original; } }, 1200);
}
});
// Quantity +/- and remove inside cart drawer / cart page
document.addEventListener('click', async e => {
const qtyBtn = e.target.closest('[data-qty-change]');
const remove = e.target.closest('[data-cart-remove]');
if (!qtyBtn && !remove) return;
e.preventDefault();
const row = e.target.closest('[data-line]');
if (!row) return;
const line = parseInt(row.dataset.line, 10);
let qty = 0;
if (qtyBtn) {
const input = row.querySelector('[data-qty-input]');
qty = Math.max(0, parseInt(input.value, 10) + parseInt(qtyBtn.dataset.qtyChange, 10));
}
row.style.opacity = '0.5';
await Cart.change(line, qty);
if (document.querySelector('[data-cart-page]')) await Cart.refreshPage(); else await Cart.refreshDrawer();
});
document.addEventListener('change', async e => {
const input = e.target.closest('[data-qty-input]');
if (!input) return;
const row = input.closest('[data-line]');
if (!row) return;
await Cart.change(parseInt(row.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
if (document.querySelector('[data-cart-page]')) await Cart.refreshPage(); else await Cart.refreshDrawer();
});
// Generic quantity stepper (product page)
document.addEventListener('click', e => {
const b = e.target.closest('[data-step]');
if (!b) return;
const input = b.parentElement.querySelector('input');
const v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
input.value = v;
});
/* ---------- Product variant picker ---------- */
$$('[data-product]').forEach(root => {
const jsonEl = $('[data-product-json]', root);
if (!jsonEl) return;
const product = JSON.parse(jsonEl.textContent);
const form = $('form[data-ajax-cart]', root) || $('form', root);
const idInput = form && form.querySelector('[name="id"]');
const priceEl = $('[data-product-price]', root);
const btn = form && form.querySelector('[type="submit"]');
const btnLabel = btn && (btn.querySelector('[data-label]') || btn);
const gallery = $('[data-gallery]', root);
function selectedOptions() {
return product.options.map((_, idx) => {
const checked = root.querySelector(`[data-option-index="${idx}"] input:checked`);
const select = root.querySelector(`select[data-option-index="${idx}"]`);
return checked ? checked.value : (select ? select.value : null);
});
}
function findVariant(opts) {
return product.variants.find(v => v.options.every((o, i) => o === opts[i]));
}
function updateAvailability(opts) {
product.options.forEach((_, idx) => {
$$(`[data-option-index="${idx}"] .option__value`, root).forEach(wrap => {
const val = wrap.querySelector('input').value;
const test = opts.slice(); test[idx] = val;
const match = product.variants.find(v => v.options.every((o, i) => i === idx ? o === val : (opts[i] == null || o === opts[i])));
wrap.classList.toggle('is-unavailable', !(match && match.available));
});
});
}
function render() {
const opts = selectedOptions();
const variant = findVariant(opts);
product.options.forEach((name, idx) => {
const label = root.querySelector(`[data-option-index="${idx}"] [data-selected-value]`);
if (label) label.textContent = opts[idx] || '';
});
updateAvailability(opts);
if (!variant) {
if (btn) { btn.setAttribute('aria-disabled', 'true'); btnLabel.textContent = theme.strings.unavailable; }
return;
}
if (idInput) idInput.value = variant.id;
if (priceEl) {
let html = '';
if (variant.compare_at_price && variant.compare_at_price > variant.price) {
html = `<span class="price price--sale"><span class="price__regular">${formatMoney(variant.compare_at_price)}</span><span class="price__sale">${formatMoney(variant.price)}</span></span>`;
} else {
html = `<span class="price">${formatMoney(variant.price)}</span>`;
}
priceEl.innerHTML = html;
}
if (btn) {
if (variant.available) { btn.removeAttribute('aria-disabled'); btnLabel.textContent = theme.strings.addToCart; }
else { btn.setAttribute('aria-disabled', 'true'); btnLabel.textContent = theme.strings.soldOut; }
}
if (variant.featured_media && gallery) {
const target = gallery.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
if (target) {
if (window.matchMedia('(max-width: 989px)').matches) gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
else target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}
}
const url = new URL(window.location.href);
url.searchParams.set('variant', variant.id);
window.history.replaceState({}, '', url.toString());
}
root.addEventListener('change', e => { if (e.target.closest('[data-option-index]')) render(); });
if (btn) btn.addEventListener('click', e => { if (btn.getAttribute('aria-disabled') === 'true') e.preventDefault(); });
render();
});
/* ---------- Newsletter popup ---------- */
const popup = $('[data-popup]');
function closePopup() { if (popup) { popup.classList.remove('is-open'); } }
if (popup) {
const key = 'esco-popup-dismissed';
const days = parseInt(popup.dataset.days, 10) || 3;
const delay = (parseInt(popup.dataset.delay, 10) || 5) * 1000;
const testMode = popup.dataset.test === 'true';
let dismissedAt = null;
try { dismissedAt = localStorage.getItem(key); } catch (e) {}
const expired = !dismissedAt || (Date.now() - parseInt(dismissedAt, 10)) > days * 86400000;
const isDesignMode = window.Shopify && window.Shopify.designMode;
if ((expired || testMode) && !isDesignMode && !window.location.search.includes('customer_posted')) {
setTimeout(() => popup.classList.add('is-open'), delay);
}
popup.addEventListener('click', e => {
if (e.target.closest('[data-popup-close]') || e.target.classList.contains('popup__backdrop')) {
closePopup();
try { localStorage.setItem(key, String(Date.now())); } catch (err) {}
}
});
}
/* ---------- Theme editor hooks ---------- */
document.addEventListener('shopify:section:select', e => {
const p = e.target.querySelector('[data-popup]');
if (p) p.classList.add('is-open');
const d = e.target.querySelector('.drawer');
if (d) openDrawerById(d.id);
});
document.addEventListener('shopify:section:deselect', e => {
const p = e.target.querySelector('[data-popup]');
if (p) p.classList.remove('is-open');
closeDrawers();
});
})();